var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"tick_icon","d":"M3.781,7a1.782,1.782,0,0,1-1.229-.49L.227,4.253A.75.75,0,0,1,1.272,3.177L3.589,5.426a.279.279,0,0,0,.205.074A.3.3,0,0,0,4,5.4L8.7.245A.75.75,0,1,1,9.8,1.255L5.111,6.411A1.789,1.789,0,0,1,3.849,7H3.781","transform":"translate(0 1.5)","fill":"current"}));
}

Check.defaultProps = {"id":"Tick_inactive","data-name":"Tick/inactive","width":"10","height":"10","viewBox":"0 0 10 10"};

module.exports = Check;

Check.default = Check;
